import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class DataShareService {

  constructor() { }

  public isEmailValidating: boolean;
  public isGovernmentIdValidating: boolean;
  public isVatIDValidating: boolean;

  private messageSource = new BehaviorSubject<String>("");
  currentMessage = this.messageSource.asObservable();

  private customerServiceSource = new BehaviorSubject<String>("");
  customerServiceMessage = this.customerServiceSource.asObservable();

  private onCloseAllTabsSource = new BehaviorSubject<String>("");
  onCloseAllTabsMessage = this.onCloseAllTabsSource.asObservable();


  private customerServiceFBOInfoSource = new BehaviorSubject<any>(null);
  getCustomerServiceFBOInfoMessage = this.customerServiceFBOInfoSource.asObservable();


  changeMessage(message: String) {
    this.messageSource.next(message)
  }

  /**
   * for customer service right content width
   * @param message 
   */
  changeCustomerServiceMessage(message: String) {
    this.customerServiceSource.next(message)
  }

  /**
   * When we click on 'Remove all tabs' then after removing in ui it should not display.
   * @param message 
   */
  changeCloseAllTabsMessage(message: String) {
    this.onCloseAllTabsSource.next(message)
  }


  setCustomerFBOInfoServiceMessage(message: any) {
    this.customerServiceFBOInfoSource.next(message)
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/data.service.ts